import $ from "jquery";
import "waypoints/lib/jquery.waypoints";
let Notifications;

let url_to_array;

url_to_array = require("../helpers/url_to_array").default;

Notifications = (() => {
    function Notifications() {
        let $activity;
        let $loading;
        let loading;
        let no_results;
        let page;
        let url;
        $activity = $("#activity-list");
        url = `//${url_to_array[2]}/${url_to_array[3]}/activity/`;
        page = 2;
        no_results = void 0;
        loading =
            '<div class="loading clearfix"> <div class="dot dot1"></div> <div class="dot dot2"></div> <div class="dot dot3"></div> <div class="dot dot4"></div> </div>';
        $activity.parent().append(loading);
        $loading = $(".loading");
        $loading.addClass("hidden");

        // clear notifications
        $.get("/clear-notications/").done(() => {
            console.log("cleared notification");
        });

        $("#logout-form").waypoint({
            handler: () => {
                if (no_results !== true) {
                    $loading.removeClass("hidden");
                    if (!this.fetching) {
                        this.fetching = true;
                        return $.get(`${url}?page=${page}`, data => {
                            this.fetching = false;
                            page = page + 1;
                            $activity.append(data);
                            $(".loading").addClass("hidden");
                            Waypoint.refreshAll();
                        }).fail(() => {
                            this.fetching = false;
                            $loading.addClass("hidden");
                            return (no_results = true);
                        });
                    }
                }
            },
            offset: "110%"
        });
    }

    return Notifications;
})();

export default Notifications;
